import { apiRequest } from "./api";
import { invalidateLivePassport } from "./passport-refresh";

export interface ShoppingRangeState {
  shopping_range: { low: number; high: number } | null;
  revision: number;
  base_target_id: string | null;
}

export function getShoppingRange(token: string) {
  return apiRequest<ShoppingRangeState>("/api/readiness/shopping-range", {
    token,
  });
}

export async function saveShoppingRange(
  token: string,
  state: ShoppingRangeState,
  low: number,
  high: number,
) {
  const result = await apiRequest<ShoppingRangeState>(
    "/api/readiness/shopping-range",
    {
      method: "PUT",
      token,
      body: {
        low,
        high,
        revision: state.revision,
        base_target_id: state.base_target_id,
      },
    },
  );
  invalidateLivePassport();
  return result;
}
